module.exports = __webpack_public_path__ + "static/media/icono-hogar.cd5da2df.svg";